var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.49989L13 6.24989M8.83331 16.3332H15.5M2.16665 12.6666L1.33331 16.3332L4.66665 15.4166L14.3216 4.79605C14.6341 4.45225 14.8096 3.98602 14.8096 3.49989C14.8096 3.01375 14.6341 2.54752 14.3216 2.20372L14.1783 2.04605C13.8658 1.70236 13.4419 1.50928 13 1.50928C12.558 1.50928 12.1342 1.70236 11.8216 2.04605L2.16665 12.6666Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.fd75c257d77315996339e09b73b66ae1.svg";
export { ForwardRef as ReactComponent };